import * as React from 'react'

import { Download } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import MapExportStore from '~/client/src/shared/components/MapExport/MapExport.store'
import TooltipWrapper from '~/client/src/shared/components/TooltipWrapper/TooltipWrapper'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  mapExportStore: MapExportStore
  size?: React.ComponentProps<typeof Button>['size']
}

// Over the map the button is its own solid ground, so it shows nothing behind it as it is pressed
// down: the translucent hover tint is laid over the background, and disabled reads muted, not faded.
const SOLID_OVER_MAP =
  'tw:hover:bg-background tw:hover:bg-linear-to-b tw:hover:from-primary-soft tw:hover:to-primary-soft tw:disabled:text-muted-foreground tw:disabled:opacity-100'

// Where its row is a container too narrow for the label beside what shares the row (Map Setup with
// both panels open), the button is its icon, named in a tooltip.
const ExportMapButton: React.FC<IProps> = ({ mapExportStore, size }) => {
  const label = Localization.translator.mapExport.exportMap
  const button = (isIconOnly: boolean): JSX.Element => (
    <Button
      variant="primary-outline"
      size={isIconOnly ? 'icon' : size}
      className={SOLID_OVER_MAP}
      aria-label={isIconOnly ? label : undefined}
      disabled={!mapExportStore.canOpen}
      onClick={mapExportStore.open}
    >
      <Download data-icon={isIconOnly ? undefined : 'inline-start'} />
      {!isIconOnly && label}
    </Button>
  )
  return (
    <>
      <span className="tw:contents tw:@max-[690px]:hidden">
        {button(false)}
      </span>
      <TooltipWrapper
        content={label}
        className="tw:hidden tw:@max-[690px]:inline-flex"
      >
        {button(true)}
      </TooltipWrapper>
    </>
  )
}

export default observer(ExportMapButton)
